import ButtonSimpleView from './ButtonSimpleView'

export default ButtonSimpleView
